import React, {Dispatch, FC, SetStateAction, useCallback} from 'react'

import cn from 'classnames/bind'

import ChevronLeft from 'src/assets/icons/chevron-left.svg'
import ChevronRight from 'src/assets/icons/chevron-right.svg'

import s from './PayStubChooseTemplateNew.module.scss'

const cx = cn.bind(s)

type TTemplatePagination = {
	className?: string
	payStubs: number
	setActiveDataTemplate: Dispatch<SetStateAction<number>>
	activeDataTemplate: number
}

export const TemplatePagination: FC<TTemplatePagination> = ({
	payStubs,
	activeDataTemplate,
	setActiveDataTemplate,
	className,
}) => {
	const prevActiveDataTemplate = useCallback(() => {
		setActiveDataTemplate((prev) => prev - 1)
	}, [setActiveDataTemplate])

	const nextActiveDataTemplate = useCallback(() => {
		setActiveDataTemplate((prev) => prev + 1)
	}, [setActiveDataTemplate])

	const chooseActiveDataTemplate = useCallback(
		(index: number) => {
			setActiveDataTemplate(index)
		},
		[setActiveDataTemplate],
	)

	return (
		<div className={cx('pagination', className)}>
			<ul className={cx('pagination__list')}>
				<button
					type="button"
					onClick={prevActiveDataTemplate}
					className={cx('nav-btn-prev', 'nav-btn', {
						'nav-btn__icon--disabled': activeDataTemplate === 0,
					})}>
					<ChevronLeft className={cx('pagination__chevron')} />
				</button>
				{Array.from(Array(payStubs).keys()).map((item, index) => (
					<li
						key={index}
						aria-hidden="true"
						data-testid="pagination-item"
						onClick={() => chooseActiveDataTemplate(index)}
						className={cx('pagination__item', activeDataTemplate === index ? 'active' : '')}>
						{index + 1}
					</li>
				))}
				<button
					type="button"
					onClick={nextActiveDataTemplate}
					className={cx('nav-btn-next', 'nav-btn', {
						'nav-btn__icon--disabled': activeDataTemplate === payStubs - 1,
					})}>
					<ChevronRight className={cx('pagination__chevron')} />
				</button>
			</ul>
		</div>
	)
}
